import { Box, type BoxProps } from '@mantine/core'
import { type PropsWithChildren } from 'react'

import classes from '../../styles.module.css'

export const BadgeEditableDropdown = ({
  children,
  ...props
}: PropsWithChildren<BoxProps>) => {
  return (
    <Box className={classes.dropdown} {...props}>
      {children}
    </Box>
  )
}

BadgeEditableDropdown.displayName = 'BadgeEditable.Dropdown'
